import { gql } from 'apollo-boost';

export const GET_SUB_PROJECT = gql`
  query GetSubProject($id: Int!) {
    getSubProject(id: $id) {
      subprojectNameUrlFriendly
      isRental
      status
      hidePrices
      project {
        ... on object_Project {
          id
          projectNameUrlFriendly
        }
      }
      children {
        ... on object_folder {
          children {
            ... on object_ConstructionNumber {
              id
              address
              active
              constructionNumber
              status
              statusInOption
              indicativePrice
              indicativePriceMax
              definitivePrice
              rentPrice
              livingArea
              parcelArea
              volume
              isBuildingPlot
              housingKind
              typeCluster
              housingVariant
              housingTypeCrm
              housingType {
                ... on object_HousingType {
                  id
                  active
                  description
                  mainThumbnail
                  imageThumbnails
                }
              }
            }
            ... on object_HousingType {
              id
              active
              description
              mainThumbnail
              imageThumbnails
            }
          }
        }
      }
    }
  }
`;
